import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '@shared/services';
import { Observable } from 'rxjs';
import { AggregatedJobData } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class AggregatedJobService extends ApiService<any> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'aggregated/job-description/';
  }

  getAggregatedJobsData(jobsIds: number[], filters?: any): Observable<AggregatedJobData[]> {
    const ids = jobsIds.join(',');
    return this.post({
      url: `?aggregation&ids=${ids}`,
      body: filters,
    });
  }
}
